export default "__VITE_ASSET__A2d_F0PN__"